<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-evgBiz-evgPurchaseOrder',
  components: { PageTable },
}
</script>
